import styled, { css } from "styled-components";

export const Title = styled.h3`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.dark_background};
    align-self: center;
    margin-bottom: 2rem;
  `}
`;

export const ContainerBanks = styled.div`
  ${({ theme }) => css`
    margin-bottom: 2rem;
    margin: 0 auto;
    margin-bottom: 2rem;

    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: ${theme.breakpoints.xxlarge}) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: ${theme.breakpoints.large}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${theme.breakpoints.small}) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;

export const BankItem = styled.div`
  width: 14.5rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;

  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-bottom: -5px;
  }

  div {
    strong {
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.5rem;
    }

    p {
      font-size: 0.87rem;
      font-weight: 400;
      line-height: 1.5rem;
      margin-top: -0.4rem;
    }
  }
`;
